<template>
  <div class="makeorder-page-table-req-width">
    <div class="makeorder-page-table-mobile-header">Req.</div>
    <div class="req-content">
      {{ quantity }}
      <span
        @click.stop="openHistory"
        class="material-icons-outlined history-icon"
        title="Ver histórico"
      >
        query_stats
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuantityLine",
  props: ["quantity", "product"],
  methods: {
    openHistory() {
      this.$emit("open-history", this.product);
    },
  },
};
</script>
<style scoped>
.makeorder-page-table-req-width {
  width: 7%;
  display: flex;
  align-items: center;
}
.req-content {
  display: flex;
  align-items: center;
  gap: 3px;
}

.history-icon {
  font-size: 1rem;
  color: var(--primary-color);
  cursor: pointer;
  transition: color 0.2s;
  padding: 5px;
}

.history-icon:hover {
  opacity: 0.8;
}

.makeorder-page-table-mobile-header {
  display: none;
}

@media screen and (max-width: 850px) {
  .makeorder-page-table-req-width {
    display: flex;
    gap: 2vw;
    align-items: center;
    width: fit-content !important;
  }
  .makeorder-page-table-mobile-header {
    display: flex;
    font-weight: bold;
    font-size: 1rem;
  }
  .history-icon {
    font-size: 1.4em;
    padding: 8px;
    margin-left: 5px;
  }
}
</style>
